const { ENV, STAGE, CONFIG_BY_STAGE, LOCALE, TIME_ZONE, VERSION } = window.__ENVIRONMENT__
const { CONFIG_BY_ENV } = CONFIG_BY_STAGE[STAGE]
const { API_HOST, KEYCLOAK_HOST, CLEARING_HOUSES, CLUSTER_NAME } = CONFIG_BY_ENV[ENV]
export { ENV, API_HOST, KEYCLOAK_HOST, CLEARING_HOUSES, CLUSTER_NAME, VERSION, STAGE, LOCALE, TIME_ZONE }
